import DOMPurify from "dompurify";

export default {
  install(app: any) {
    app.config.globalProperties.$sanitize = (html: string) => {
      return DOMPurify.sanitize(html);
    };
  },
};
